import { styled } from '@mui/material/styles';

export const FlexBox = styled('div')(({ $mt }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: $mt !== undefined ? `${$mt}px` : '0px'
}));

export const Icon = styled('span')(() => ({}));

export const TextFieldContainer = styled('div')(({ $mt }) => ({
  marginTop: $mt !== undefined ? `${$mt}px` : '0px',
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  maxWidth: '160px'
}));

export const List = styled('ul')(({ $ml, $mt }) => ({
  marginLeft: $ml !== undefined ? `${$ml}px` : '0px',
  marginTop: $mt !== undefined ? `${$mt}px` : '0px'
}));

export const ListItem = styled('li')(() => ({}));

export const Value = styled('span')(() => ({}));
